import { useState } from "react";
import axios from "axios";
import retry from "async-retry";
import { kazooLog } from "../index";

import Input from "../Components/Input";
import Results from "../Components/Results";

const SearchPage = ({
  API_URL,
  audioRef,
  setTitle,
  setTotal,
  setCurrentId,
  setDownloading,
  setPosition,
  setProgress,
}) => {
  const [results, setResults] = useState(null);
  const [inputValue, setInputValue] = useState("");
  return (
    <>
      {
        <>
          <Input
            label={"Band or song name"}
            inputValue={inputValue}
            setInputValue={setInputValue}
            handleOnSubmit={(e) => {
              e.preventDefault();
              (async () => {
                const apiData = await axios.get(
                  API_URL + "/search/" + inputValue
                );
                kazooLog(inputValue);
                console.log(apiData.data.videos);
                setResults(apiData.data.videos);
                e.target.blur();
              })();
            }}
          />
        </>
      }

      {results ? (
        <Results
          results={results}
          handleOnResultClick={async (el) => {
            setTitle(el.title);
            setTotal(el.timestamp);
            setCurrentId(null);
            setDownloading(true);
            await axios.get(API_URL + "/download/" + el.videoId);
            (async () => {
              retry(
                async () => {
                  console.log("try");
                  const data = await axios.get(
                    API_URL + "/ready/" + el.videoId
                  );
                  console.log("axios data", data);
                  if (data.data.progress) {
                    setPosition(null);
                    setProgress(data.data.progress.slice(0, -3));
                  }
                  if (data.data.position) {
                    setPosition(data.data.position);
                  }
                  if (!data.data.exists) {
                    throw new Error("Retry");
                  }
                  // This is not executed if an error is thrown
                  setDownloading(false);
                  setProgress(null);
                  setPosition(null);
                  setTotal(null);
                  // setCurrentId(el.videoId);
                  audioRef.current.setAttribute(
                    "src",
                    API_URL + "/video/" + el.videoId
                  );
                  audioRef.current.play();
                  return data;
                },
                {
                  retries: 300,
                  randomize: false,
                  factor: 1,
                  minTimeout: 1000,
                }
              );
            })();
          }}
        />
      ) : null}
    </>
  );
};

export default SearchPage;
